
import DAL, {mongoObjectId} from './../js/Sync/dal';
var getOrientedImage = require('exif-orientation-image');

var formUploadHandler = {
    data() {
        return {
            base64: ''
        }
    },
    methods: {
        doremoveUpload(uploadId) {

            console.log("UPLOADID removing", uploadId, this.localImages);
            
            var _this = this;

            _this.localImages = _this.localImages.filter(function (ul) {
                return ul.id != uploadId;
            });
            console.log("UploadId", uploadId);
            //_this.$emit('removeImagePopup', uploadId);
            
            DAL.removeItem("MTTempImages", uploadId).then(function (result) {
                console.log("Image removed as well");
            });

        },

        process(arrayB){
            var dv = new DataView(new ArrayBuffer(arrayB.toString()));
            var offset = 0, recess = 0;
            var pieces = [];
            var i = 0;
            if (dv.getUint16(offset) == 0xffd8){
                offset += 2;
                var app1 = dv.getUint16(offset);
                offset += 2;
                while (offset < dv.byteLength){
                    if (app1 == 0xffe1){
                        
                        pieces[i] = {recess:recess,offset:offset-2};
                        recess = offset + dv.getUint16(offset);
                        i++;
                    }
                    else if (app1 == 0xffda){
                        break;
                    }
                    offset += dv.getUint16(offset);
                    var app1 = dv.getUint16(offset);
                    offset += 2;
                }
                if (pieces.length > 0){
                    var newPieces = [];
                    pieces.forEach(function(v){
                        newPieces.push(arrayB.slice(v.recess, v.offset));
                    }, this);
                    newPieces.push(arrayB.slice(recess));
                    return new Blob(newPieces, {type: 'image/jpeg'});
                }
            }
        },

        gotUpload (event) {
            var _this = this;

            var file = '';
            var res = '';
            var fullres = '';
            var fullimg = '';

            console.log("gotUpload : event", event);

            if(event.target.files.length == 1 && event.target.files[0].type.indexOf("image/") == 0) {

                var reader = new FileReader();

                reader.onload = function (theFile) {

                    var imageId = mongoObjectId();
                    var customerId;

                    var randomNamePart = mongoObjectId();
                    
                    var numberInIndexedDB = 1;
                    DAL.iterate('MTTempImages', function(value, key, iterationNumber) {
                        console.log('value.projectId == _this.filteredResult.id', value.projectId == _this.filteredResult.id)
                        if (value.projectId == _this.filteredResult.id) {
                            numberInIndexedDB += 1;
                        }
                    })

                    var customer = JSON.parse(_this.$cookie.get('user'));

                    DAL.getItem("MTUsers", "users").then(function (result) {
                        
                        customerId = customer.id;
                        file = event.target.files[0];
                        
                        return new Promise(function (resolve, reject) {
                            getOrientedImage(file,function(err,canvas) {
                                if (!err) {
                                    canvas.toBlob(function (blob) {
                                            resolve(blob);
                
                                    }, 'image/jpeg', 1);
                                }
                            });
                        })
                        
                    })
                    .then(function(orientedImageBlob) {
                        new Promise(function(resolve, reject) {
                            var arrayBuffer;
                            var fileReader = new FileReader();
                            fileReader.onload = function() {
                                var arrayBf = fileReader.result;
                                console.log("arrayBf", arrayBf);
                                

                                //resolve(_this.process(this.result));
                                resolve(this.result);
                            };
                            fileReader.readAsArrayBuffer(orientedImageBlob);
                        }).then(function(orientedImageArrayBuffer) {
                            //Create thumbnail
                            fullres = orientedImageArrayBuffer;
                            return _this.createThumbnail(orientedImageArrayBuffer, event.target.files[0].type)
                        }).then(function(result) {
                            res = result;
                            return _this.createThumbnail(fullres, event.target.files[0].type, 800, 1)
                        }).then(function(result) {
                            fullimg = result;
                            console.log("result", result);
                            return new Promise(function(resolve, reject) {
                                 var readerFull = new window.FileReader();

                                 readerFull.readAsDataURL(new Blob([new Uint8Array(result)])); 
                                 readerFull.onloadend = function() {
                                    var base64data = readerFull.result;                
                                    resolve(base64data);
                                 } 
                            })
                        })

                        .then( function (base64) {
                            console.log("base64 after", base64.length)
                            _this.base64 = base64;
                            var imageObj = {
                                "id": imageId,
                                "thumb": res,
                                "data" : fullimg,
                                "base64" : _this.base64,
                                "mongoObjectId" : mongoObjectId(),
                                "type" : file.type,
                                "state" : "saved",
                                "fileName" : _this.filteredResult.maalernummer + '_' + numberInIndexedDB + '.jpg',
                                "filePath" : "CustomerData\\" + customerId + "\\Projects\\" + _this.filteredResult.id,
                                "projectId" : _this.filteredResult.id
                            }
                            console.log('imageObj', imageObj)

                            _this.localImages.push(imageObj);
                            return DAL.setItem("MTTempImages", imageId, imageObj);
                        }).then(function (result) {
                            var uploadObj = {
                                "uploadId" : mongoObjectId(),
                                "fileName" : _this.filteredResult.maalernummer + '_' + numberInIndexedDB + '.jpg',
                                "filePath" : "CustomerData\\" + customerId + "\\Projects\\" + _this.filteredResult.id,
                                "createdDateTime" : new Date().toISOString(),
                                "caption" : "",
                                "tags" : [],
                                "imageId" : imageId
                            };
                            console.log('uploadObj', uploadObj)
                            _this.$store.dispatch('updateNotification', 1);
                            _this.$emit('uploadObj', uploadObj);

                            console.log("localImages", _this.localImages);

                            event.target.value = "";
                        });
                    })
                };
                reader.readAsArrayBuffer(event.target.files[0]);
            }
        },
        gotScreenshot (base64Image) {            
            var _this = this;
            
            var file = this.dataURLtoFile(base64Image, 'Screenshot');
            var res = '';
            var fullres = '';
            var fullimg = '';

            var reader = new FileReader();

            reader.onload = function (theFile) {

                var imageId = mongoObjectId();
                var customerId;

                var randomNamePart = mongoObjectId();
                
                var numberInIndexedDB = 1;
                DAL.iterate('MTTempImages', function(value, key, iterationNumber) {
                    console.log('value.projectId == _this.filteredResult.id', value.projectId == _this.filteredResult.id)
                    if (value.projectId == _this.filteredResult.id) {
                        numberInIndexedDB += 1;
                    }
                })

                var customer = JSON.parse(_this.$cookie.get('user'));

                DAL.getItem("MTUsers", "users").then(function (result) {
                    
                    customerId = customer.id;
                    
                    return new Promise(function (resolve, reject) {
                        getOrientedImage(file,function(err,canvas) {
                            if (!err) {
                                canvas.toBlob(function (blob) {
                                        resolve(blob);
            
                                }, 'image/jpeg', 1);
                            }
                        });
                    })
                    
                })
                .then(function(orientedImageBlob) {
                    new Promise(function(resolve, reject) {
                        var arrayBuffer;
                        var fileReader = new FileReader();
                        fileReader.onload = function() {
                            var arrayBf = fileReader.result;
                            console.log("arrayBf", arrayBf);
                            

                            //resolve(_this.process(this.result));
                            resolve(this.result);
                        };
                        fileReader.readAsArrayBuffer(orientedImageBlob);
                    }).then(function(orientedImageArrayBuffer) {
                        //Create thumbnail
                        fullres = orientedImageArrayBuffer;
                        return _this.createThumbnail(orientedImageArrayBuffer, file.type)
                    }).then(function(result) {
                        res = result;
                        return _this.createThumbnail(fullres, file.type, 800, 1)
                    }).then(function(result) {
                        fullimg = result;
                        console.log("result", result);
                        return new Promise(function(resolve, reject) {
                             var readerFull = new window.FileReader();

                             readerFull.readAsDataURL(new Blob([new Uint8Array(result)])); 
                             readerFull.onloadend = function() {
                                var base64data = readerFull.result;                
                                resolve(base64data);
                             } 
                        })
                    })

                    .then( function (base64) {
                        console.log("base64 after", base64.length)
                        _this.base64 = base64;
                        var imageObj = {
                            "id": imageId,
                            "thumb": res,
                            "data" : fullimg,
                            "base64" : _this.base64,
                            "mongoObjectId" : mongoObjectId(),
                            "type" : file.type,
                            "state" : "saved",
                            "fileName" : _this.filteredResult.maalernummer + '_' + numberInIndexedDB + '.jpg',
                            "filePath" : "CustomerData\\" + customerId + "\\Projects\\" + _this.filteredResult.id,
                            "projectId" : _this.filteredResult.id
                        }
                        console.log('imageObj', imageObj)

                        _this.localImages.push(imageObj);
                        return DAL.setItem("MTTempImages", imageId, imageObj);
                    }).then(function (result) {
                        var uploadObj = {
                            "uploadId" : mongoObjectId(),
                            "fileName" : _this.filteredResult.maalernummer + '_' + numberInIndexedDB + '.jpg',
                            "filePath" : "CustomerData\\" + customerId + "\\Projects\\" + _this.filteredResult.id,
                            "createdDateTime" : new Date().toISOString(),
                            "caption" : "",
                            "tags" : [],
                            "imageId" : imageId
                        };
                        console.log('uploadObj', uploadObj)
                        _this.$store.dispatch('updateNotification', 1);
                        _this.$emit('uploadObj', uploadObj);

                        console.log("localImages", _this.localImages);

                        // event.target.value = "";
                    });
                })
            };
            reader.readAsArrayBuffer(file);
        },
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), 
                n = bstr.length, 
                u8arr = new Uint8Array(n);
                
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            
            return new File([u8arr], filename, {type:mime});
        },
        createThumbnail (image, type, width, quality) {
            if (width == undefined) {
                width = 254;
            }

            if (quality == undefined) {
                quality = 0.7;
            }
           
            var d = new Promise((resolve, reject) => {

                var dataView = new DataView(image),
                    fullImageBlob = new Blob([dataView], { type: type }),
                    canvas = document.createElement("canvas"),
                    ctx = canvas.getContext('2d'),
                    img = new Image();

                img.onload = function() {

                    var ratio = width / img.width;
                    var newHeight = ratio * img.height;

                    canvas.height = newHeight;
                    canvas.width = width;

                    ctx.drawImage (img, 0, 0, width, newHeight);

                    canvas.toBlob(function (blob) {

                        var fr = new FileReader();

                        fr.onload = function (event) {
                            //fr.result
                            resolve(fr.result);
                        };
                        fr.readAsArrayBuffer(blob);


                    }, 'image/jpeg', quality);

                }
                img.src = URL.createObjectURL(fullImageBlob);
            });

            return d;
        }
    },
    computed: {
        mongoid: function () {
            return mongoObjectId();
        }
    },
    
}

export default formUploadHandler


// WEBPACK FOOTER //
// ./src/mixins/FormUploadHandler.js